import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchJobById } from '../services/jobService';
import ReactMarkdown from 'react-markdown';

const JobDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadJob = async () => {
      try {
        const data = await fetchJobById(id);

        // Decode escaped \n into real line breaks
        for (const key in data) {
          if (typeof data[key] === 'string') {
            data[key] = data[key].replace(/\\n/g, '\n');
          }
        }

        setJob(data);
      } catch (error) {
        console.error('Error loading job:', error);
      } finally {
        setLoading(false);
      }
    };

    loadJob();
  }, [id]);

  useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes bounce {
      from { transform: translateY(0); }
      to { transform: translateY(-10px); }
    }

    div[style*="dot"]:nth-child(1) {
      animation-delay: 0s;
    }

    div[style*="dot"]:nth-child(2) {
      animation-delay: 0.2s;
    }

    div[style*="dot"]:nth-child(3) {
      animation-delay: 0.4s;
    }
  `;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);


  const getDaysRemainingLabel = (closingDate) => {
    const today = new Date();
    const close = new Date(closingDate);
    const diffTime = close - today;
    const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (days < 0) return { label: 'Expired', color: '#d32f2f' };
    if (days <= 3) return { label: `${days} day${days === 1 ? '' : 's'} left`, color: '#fbc02d' };
    return { label: `${days} days left`, color: '#388e3c' };
  };
  

  {/**if (loading) return <p style={styles.loading}>Loading...</p>;
  if (!job) return <p style={styles.loading}>Job not found.</p>;
   const status = getDaysRemainingLabel(job.closingDate);**/}

 

  return (

    <div style={styles.pageWrapper}>
    <div style={styles.container}>
      
      {loading ? (
        <div style={styles.loader}>
        <div style={styles.dot}></div>
        <div style={styles.dot}></div>
        <div style={styles.dot}></div>
      </div>
      ) : !job ? (
        <p style={styles.loading}>Job not found.</p>
      ): (
        <>
          {/* Now it's safe to access job.closingDate */}
          {(() => {
            const status = getDaysRemainingLabel(job.closingDate);
            return (
        <>
      <div style={styles.headerRow}>
        <button onClick={() => navigate('/')} style={styles.backButton}>← Back to Home</button>
        <button onClick={() => navigate(`/EditJob/${job.id}`)} style={styles.editButton}>✏️ Edit</button>
      </div>

      <h2>{job.title}</h2>
      <p><strong>Company:</strong> {job.companyName}</p>
      <p><strong>Location:</strong> {job.location}</p>
      <p><strong>Posted Date:</strong> {job.postedDate}</p>
      <p>
        <strong>Closing Date:</strong> {job.closingDate}
        {' '}
        <span style={{ 
          backgroundColor: status.color, 
          color: '#fff', 
          padding: '2px 8px', 
          borderRadius: '12px', 
          fontSize: '12px', 
          marginLeft: '8px'
        }}>
          {status.label}
        </span>
      </p>
      <p><strong>Job Type:</strong> {job.jobType}</p>
      <p><strong>Education Level:</strong> {job.educationLevel}</p>
      <p><strong>Experience Level:</strong> {job.experienceLevel}</p>
      <p><strong>Salary Range:</strong> {job.salaryRange}</p>

      <div style={styles.section}>
        <h3>Description</h3>
        <ReactMarkdown>{job.description}</ReactMarkdown>
      </div>

      <div style={styles.section}>
        <h3>Responsibilities</h3>
        <ReactMarkdown>{job.jobResponsibilities}</ReactMarkdown>
      </div>

      <div style={styles.section}>
        <h3>Requirements</h3>
        <ReactMarkdown>{job.requirements}</ReactMarkdown>
      </div>

      <div style={styles.section}>
        <h3>Company Details</h3>
        <ReactMarkdown>{job.companyDetails}</ReactMarkdown>
      </div>

      <div style={styles.section}>
        <h3>Application Method</h3>
        <ReactMarkdown>{job.applicationMethod}</ReactMarkdown>
      </div>

      {job.imgUrl && (
        <div style={styles.imageContainer}>
          <img src={job.imgUrl} alt="Job" style={styles.image} />
        </div>
      )}
     </>
       );
          })()}
        </>
      )}
    </div>
    </div>
     
  );
};

const styles = {
  pageWrapper: {
  minHeight: '100vh',
  width: '100%',
  backgroundColor: '#f4f6f8', // light background
  padding: '40px 20px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start', // or 'center' if you want vertical center
},

card: {
  width: '100%',
  maxWidth: '800px',
  minHeight: '600px',
  background: '#fff',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  padding: '20px',
  boxSizing: 'border-box',
}
,
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  backButton: {
    padding: '6px 12px',
    backgroundColor: '#9e9e9e',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  editButton: {
    padding: '6px 12px',
    backgroundColor: '#1976d2',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  section: {
    marginTop: '20px',
  },
  imageContainer: {
    marginTop: '20px',
  },
  image: {
    maxWidth: '100%',
    borderRadius: '8px',
  },
  loading: {
    textAlign: 'center',
    marginTop: '40px',
    fontSize: '18px',
  },
  loader: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '6px',
  height: '300px',
},

dot: {
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  backgroundColor: '#004d40',
  animation: 'bounce 0.6s infinite ease-in-out alternate',
},

// We'll apply staggered animation via CSS selector below

};

export default JobDetails;
